import { useEffect, useState } from 'react'
import { apiFetch } from '../../lib/api'
import { useAuthSession } from '../../lib/authSession'

/** A result belongs to its complete URL and login session, even before effect cleanup. */
export function useRead<T>(url: string | null, refresh = 0) {
  const session = useAuthSession()
  const key = JSON.stringify([url, session, refresh])
  const [result, setResult] = useState<{ key: string; value?: T; error?: unknown } | null>(null)
  useEffect(() => {
    if (!url || !session) return
    const controller = new AbortController()
    apiFetch<T>(url, { signal: controller.signal })
      .then((value) => {
        if (!controller.signal.aborted) setResult({ key, value })
      })
      .catch((error) => {
        if (!controller.signal.aborted) setResult({ key, error })
      })
    return () => controller.abort()
  }, [url, session, key])
  const current = result?.key === key ? result : null
  return { value: current?.value, error: current?.error, loading: !!url && !current }
}

export function useContextualNavigation() {
  return useRead<{ enabled: boolean }>('/api/navigation/capabilities')
}
